import { render, staticRenderFns } from "./aFeeDetailSub.vue?vue&type=template&id=14a5fb56&scoped=true"
import script from "./aFeeDetailSub.vue?vue&type=script&lang=js"
export * from "./aFeeDetailSub.vue?vue&type=script&lang=js"
import style0 from "./aFeeDetailSub.vue?vue&type=style&index=0&id=14a5fb56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a5fb56",
  null
  
)

export default component.exports